import flatpickr from "flatpickr";
import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = [ "extendPickerDate", "extendPickerTime"];
    connect()
    {
        let testExpireDate = this.element.dataset["testExpireDate"];

        let datePicker = flatpickr(this.extendPickerDateTarget, {
            altInput: true,
            altFormat: "F j, Y",
            dateFormat: "Y-m-d"
        });
        let timePicker = flatpickr(this.extendPickerTimeTarget,
        {
            enableTime: true,
            noCalendar: true,
            altInput: true,
            dateFormat: "H:i"
        });

        datePicker.setDate(testExpireDate);
        timePicker.setDate(testExpireDate.split(" ")[1]);
    }

    handleExtendTestResponse(event)
	{
		if (event.detail[0].success)
		{
			const successEvent = new CustomEvent("show-toast", { detail: "Test successfully extended!" });
			window.dispatchEvent(successEvent);

            let form = event.target;

            let wrapper = form.closest(".wrapper");
            
            let actions = wrapper.querySelector(".actions"),
                extendButton = actions.children[0],
                cancelButton = actions.children[1];

            cancelButton.classList.add("hidden");
            extendButton.classList.remove("hidden");

            let selectedDate = form.querySelector('input[name="expire_date"]').value,
                selectedTime = form.querySelector('input[name="expire_time"]').value;

            let date = new Date(`${selectedDate}T${selectedTime}:00`);

            let expireDate = wrapper.querySelector(".test-expire").lastElementChild;

            expireDate.innerText = `${date.toLocaleDateString("en-US", { day:"2-digit",month:"2-digit", year:"2-digit" })} ${date.toLocaleTimeString()}`;
            this.element.previousElementSibling.firstElementChild.dataset.testExpireDate = `${selectedDate} ${selectedTime}:00`;

            wrapper.querySelector(".extend-test").remove();

		}
		else
		{
			const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: " + event.detail[0].error });
			window.dispatchEvent(errorEvent);
		}
	}
}